<app-nav></app-nav>

<div *ngIf="isLoading" class="outer-spinner">
  <div class="loading-spinner"></div>
</div>

<main class="page" *ngIf="!isLoading">

  <section class="profile-card">
    <div class="banner"></div>

    <div class="top">
      <img [src]="photo" (error)="$any($event.target).src='assets/images/avatar.png'" class="avatar" alt="" />

      <div class="id">
        <h1>{{ name }}</h1>
        <p class="sub" *ngIf="subtitle">{{ subtitle }}</p>
        <p class="loc" *ngIf="location"><i class="fa-solid fa-location-dot"></i> {{ location }}</p>
      </div>

      <div class="actions">
        <button type="button" class="b-pink" *ngIf="friend.contacted == 'none'" [disabled]="sending" (click)="sendRequest()">
          <i class="fa-solid fa-user-plus"></i> {{ sending ? 'Sending...' : 'Send Request' }}
        </button>
        <span class="pending" *ngIf="friend.contacted == 'Pending'">
          <i class="fa-solid fa-hourglass-half"></i> Request Pending
        </span>
        <button type="button" class="b-pink" *ngIf="friend.contacted == 'Accepted'" (click)="sendMessage()">
          <i class="fa-solid fa-comment-dots"></i> Send Message
        </button>
      </div>
    </div>

    <div class="grid">
      <div class="box">
        <h3>About</h3>
        <div class="field" *ngIf="u.firstname"><span>First Name</span><b>{{ u.firstname }}</b></div>
        <div class="field" *ngIf="u.lastname"><span>Last Name</span><b>{{ u.lastname }}</b></div>
        <div class="field" *ngIf="u.job_title"><span>Job Title</span><b>{{ u.job_title }}</b></div>
        <div class="field" *ngIf="u.company"><span>Company</span><b>{{ u.company }}</b></div>
        <div class="field" *ngIf="u.country"><span>Country</span><b>{{ u.country }}</b></div>
      </div>

      <div class="box">
        <h3>Contact</h3>
        <p class="line" *ngIf="u.email"><i class="fa-solid fa-envelope"></i> {{ u.email }}</p>
        <p class="line" *ngIf="u.phone"><i class="fa-solid fa-phone"></i> {{ u.phone }}</p>
        <p class="line" *ngIf="u.website"><i class="fa-solid fa-globe"></i> {{ u.website }}</p>
        <p class="line" *ngIf="location"><i class="fa-solid fa-location-dot"></i> {{ location }}</p>

        <ng-container *ngIf="socials.length">
          <h3 class="mt">Social Profiles</h3>
          <div class="socials">
            <a *ngFor="let s of socials" [href]="s.url" target="_blank" rel="noopener" [title]="s.label">
              <i [class]="s.icon"></i>
            </a>
          </div>
        </ng-container>
      </div>
    </div>
  </section>
</main>